import { Controller } from '@hotwired/stimulus'
import axios from 'axios'


export default class extends Controller {
  static targets = [
    'icon'
  ]

  static values = {
    organizationId: { type: String, default: '' }
  }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('inboxes sync controller connected.')
  }

  disconnect() {
  }

  sync(evt) {
    evt.preventDefault()
    this.iconTarget.classList.add('fa-spin')

    axios.post(`/ajax/organizations/${this.organizationIdValue}/sync_inboxes`)
      .then((response) => {
        this.iconTarget.classList.remove('fa-spin')
      }).catch((error) => {
        console.log(error)
      })
  }
}
